// app/javascript/src/models/animals/usage_other_controller.js

// Controle do campo "Outros" para usages
// Mostra/oculta o input usage_other quando o checkbox "Outros" é marcado

// Evento change para mostrar/ocultar
document.addEventListener('change', function(event) {
    var checkbox = event.target;

    if (checkbox.matches('.usage-other-checkbox')) {
        var container = checkbox.closest('.usage-group').querySelector('.usage-other-container');
        var input = container ? container.querySelector('input') : null;

        if (checkbox.checked) {
            container.style.display = 'block';
            if (input) input.focus();
        } else {
            container.style.display = 'none';
            if (input) input.value = '';
        }
    }
});

// Garantir que NOVOS clones do multi-animal tenham o container oculto
document.addEventListener('DOMContentLoaded', function() {
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            // Verificar apenas nós que foram ADICIONADOS
            if (mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(function(node) {
                    // Verificar se o nó adicionado é um elemento HTML
                    if (node.nodeType === 1) {
                        // Verificar se é um novo multi-animal (o próprio nó ou um descendente)
                        var animal = null;

                        // Se o nó adicionado é o próprio .multi-animal
                        if (node.classList && node.classList.contains('multi-animal')) {
                            animal = node;
                        }

                        // Se o nó adicionado contém um .multi-animal dentro
                        if (node.querySelector && node.querySelector('.multi-animal')) {
                            animal = node.querySelector('.multi-animal');
                        }

                        // Se encontrou um novo animal, resetar apenas ele
                        if (animal) {
                            var container = animal.querySelector('.usage-other-container');
                            if (container) {
                                container.style.display = 'none';
                                var input = container.querySelector('input');
                                if (input) input.value = '';
                            }
                            var checkbox = animal.querySelector('.usage-other-checkbox');
                            if (checkbox) {
                                checkbox.checked = false;
                            }
                        }
                    }
                });
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});